@if (isFooterAvailable) {
    <!------Chnages for footer when map is NOT visvible----->
    <ng-container>
        <div class="footer-container" id="footer-container">
            <footer class="amg-footer">
                <div class="nav-row">
                    <div class="footernavigation">
                        <nav>
                            <ul>
                                <li>
                                    <a
                                        target="_blank"
                                        (click)="openProviderPage()"
                                        id="footerProviderLink"
                                        ><span>{{ 'CP_LM_FOOTER_PROVIDER' | translate }}</span></a
                                    >
                                </li>
                                <li>
                                    <a
                                        target="_blank"
                                        (click)="openLegalPage()"
                                        id="footerLegalLink"
                                        ><span>{{ 'CP_LM_FOOTER_LEGAL' | translate }}</span></a
                                    >
                                </li>
                                <li style="display: none">
                                    <a id="footerSRLink"
                                        ><span>{{ 'SR_SETTINGS' | translate }}</span></a
                                    >
                                </li>
                                <li>
                                    <a
                                        target="_blank"
                                        (click)="openPrivacyPage()"
                                        id="footerPrivacyLink"
                                        ><span>{{ 'CP_LM_FOOTER_PRIVACY' | translate }}</span></a
                                    >
                                </li>
                                <li style="display: none">
                                    <a id="footerContactLink"
                                        ><span>{{ 'SR_CONTACT' | translate }}</span></a
                                    >
                                </li>
                                <li style="display: none">
                                    <a id="footerSrCcpaink"
                                        ><span>{{ 'SR_CCPA' | translate }}</span></a
                                    >
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="footernavigation language">
                        <nav>
                            @if (isLanguageSelector) {
                                <span class="menu-item top-menu-font">
                                    <span
                                        class="glow-button lang-padding"
                                        (click)="openLanguagePicker()"
                                        ><a id="footerCurrentLanguageLink"
                                            ><span>{{ languageToDisplay }}</span></a
                                        ></span
                                    >
                                </span>
                            }
                        </nav>
                    </div>
                </div>
                <div class="footer-logo">
                    <span class="footer-logo-face"></span>
                </div>
                <div class="footer-top-button" (click)="scrollTop()">
                    <button class="move-top">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            class="brandhub-back-top-button__icon"
                        >
                            <path
                                fill="currentColor"
                                fill-rule="evenodd"
                                d="m9.121 19.728-.707-.707 7.07-7.071-7.07-7.071.707-.707 7.07 7.07h.001l.707.708-7.778 7.778Z"
                            ></path>
                        </svg>
                        <span>{{ 'CP_FOOTER_TOP_LBL' | translate }}</span>
                    </button>
                </div>
            </footer>
        </div>
    </ng-container>
}
